<template>
  <div>
    <Header />
    <div class="main">
      <div class="c">
        <div class="title">
          <div class="return" @click="back()">
            <a-icon type="left" />
            <span>返回</span>
          </div>
          <span class="chapterName">{{ this.chapterName }}</span>
        </div>
        <div class="paper">
          <div class="paper-left">
            <component
              :is="tebActive"
              :questionData="questionData"
              :key="questionData.index"
            ></component>
          </div>
          <div class="paper-right">
            <div class="paper-right-title">答题卡</div>
            <div class="paper-right-selects">
              <ul class="paper-items">
                <li
                  v-for="(item, index) in questions"
                  :key="item.id"
                  ref="li"
                  :style="{
                    background:
                      index == currentIndex ? '#2462F5' : item.answerState,
                    color: index == currentIndex ? '#fff' : item.answerColor,
                  }"
                  @click="toQuestion(item, index)"
                >
                  {{ item.num }}
                  <img v-show="item.is_sign == 1"
                    src="../../../assets/sign.png"
                    alt=""/>
                </li>
              </ul>
            </div>
            <div class="tip">
              <span>已答</span>
              <div class="answered"></div>
              <span>未答</span>
              <div class="noAnswer"></div>
            </div>
            <div class="submit" @click="submit()">提交</div>
          </div>
        </div>
        <div class="button-box" v-if="this.questions.length > 1">
          <div class="buPrevious" ref="buPrevious" @click="previous()">
            上一题
          </div>
          <div class="buNext" ref="buNext" @click="next()">下一题</div>
        </div>
      </div>
    </div>
    <!-- <Footer /> -->
  </div>
</template>

<script>
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import radio from "./NowPractice/radio";
import checkbox from "./NowPractice/checkbox";
import fillBlanks from "./NowPractice/fillBlanks";
import combination from "./NowPractice/combination.vue";
import quesAnswer from "./NowPractice/quesAnswer";
import judge from "./NowPractice/judge";
import services from "../../../config/services";
import { mapState } from "vuex";
export default {
  name: "NowPractice",
  components: {
    Footer,
    Header,
    radio,
    checkbox,
    fillBlanks,
    quesAnswer,
    judge,
    combination,
  },
  data() {
    return {
      tebActive: null,
      questionData: "",
      questions: "",
      cardInfo: "", //答题卡信息
      chapter_id: this.$route.query.chapter_id,
      chapterName: this.$route.query.name,
      exe_id: this.$route.query.exe_id,
      questionId: '', //当前question id
      currentIndex: 0, //当前位置
      isAnswer: false, //是否作答
      color: "#fff",
      answerForm: {
        chapter_id: this.$route.query.chapter_id,
        exe_id: this.$route.query.exe_id,
        answer_data: [],
      },
      tab: 1,
      is_again: this.$route.query.is_again ? 1 : 2,
      isSubmitting: false, // 是否正在提交作答 避免重复提交
    };
  },
  computed: {
		...mapState({ 
			userAllInfo: state => state.appsLogin.appsUserInfo,
		}),
	},
  watch: {
    "questionData.form.is_sign": function (val) {
      this.questions[this.questionData.index].is_sign = val;
      this.$forceUpdate();
    },
    "questionData.form.answer": function (val) {
      if (val) {
        this.$set(this.questions[this.currentIndex], "answerState", "#DBE6FD");
        this.$set(this.questions[this.currentIndex], "answerColor", "#2462F5");
      }
      this.$forceUpdate();
    },
    currentIndex: function (val) {
      if (val == this.questions.length - 1) {
        this.$refs.buNext.style.background = "#ECEAEA";
        this.$refs.buNext.style.color = "#999999";
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#FFFFFF";
        this.$refs.buNext.style.cursor = "not-allowed";
        this.$refs.buPrevious.style.cursor = "pointer";
      }
      if (val == 0) {
        this.$refs.buPrevious.style.background = "#ECEAEA";
        this.$refs.buPrevious.style.color = "#999999";
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
        this.$refs.buPrevious.style.cursor = "not-allowed";
        this.$refs.buNext.style.cursor = "pointer";
      }
      if (val > 0 && val < this.questions.length - 1) {
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#999999";
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
        this.$refs.buPrevious.style.cursor = "pointer";
        this.$refs.buNext.style.cursor = "pointer";
      }
    },
  },
  created() {
    if (this.$route.query.is_again) {
      this.is_again = this.$route.query.is_again;
    }
    services
      .getUserExercisesCard({
        chapter_id: this.chapter_id,
        exe_id: this.exe_id,
        is_again: this.is_again,
      })
      .then((res) => {
        //this.is_again = 2;
        this.questions = res.data.items;
        this.questionId = this.questions[0].id
        services
          .getUserExercisesQuestion({
            chapter_id: this.chapter_id,
            exe_id: this.exe_id,
            que_id: this.questions[0].id,
            is_again: this.is_again,
          })
          .then((second) => {
            this.questions[0] =  Object.assign(this.questions[0], second.data);
            let obj1 = {
              que_id: this.questions[0].id,
              answer: "",
              is_sign: "2",
            };
            if (this.questions[0].type == "1") {
              this.tebActive = "radio";
            }
            if (this.questions[0].type == "2") {
              this.tebActive = "checkbox";
            }
            if (this.questions[0].type == "3") {
              this.tebActive = "judge";
            }
            if (this.questions[0].type == "4") {
              this.tebActive = "quesAnswer";
            }
            if (this.questions[0].type == "5") {
              this.tebActive = "combination";
            }
            this.answerForm.answer_data.push(obj1);
            this.questionData = {
              data: this.questions[0],
              index: this.currentIndex,
              form: this.answerForm.answer_data[0],
              isAssess: '1', // 1练习 2 测评
            };
          });
      });
  },
  methods: {
    // 返回
    back() {
      let code = this.userAllInfo.school_code ? this.userAllInfo.school_code : localStorage.getItem("schoolCode")
      this.$router.push({
        path: `/${code}/user/myPractice`,
      });
    },
    //跳转到该题
    async toQuestion(val, index, isRequest) {
      let that = this
      if(!isRequest){
        await this.eveyoneQuesFunc('current', this.currentIndex)
      }
      that.currentIndex = index;
      that.questionId = val.id
      
      await services.getUserExercisesQuestion({
        chapter_id: that.chapter_id,
        que_id: val.id,
        exe_id: that.exe_id,
      }).then((res) => {
        if(res.code == '0000'){
          that.questions[index] = Object.assign(that.questions[index],res.data);
          let obj = {
            que_id: that.questions[index].id,
            answer: "",
            is_sign: "2",
          };
          if(res.data.user_log && res.data.user_log.answer) {
            obj.answer = res.data.user_log.answer
          }
          if(res.data.user_log && res.data.user_log.is_sign) {
            obj.is_sign = res.data.user_log.is_sign
          }
          if (that.questions[index].type == "1") {
            that.tebActive = "radio";
          } else if (that.questions[index].type == "2") {
            that.tebActive = "checkbox";
          } else if (that.questions[index].type == "5") {
            that.tebActive = "combination"; // type 为5 组合题
            obj.attachment = res.data.user_attachment
            // this.tebActive = 'fillBlanks'; // fillBlanks 代表填空题 目前没有
          } else if (that.questions[index].type == "4") {
            that.tebActive = "quesAnswer";
            obj.attachment = res.data.user_attachment
          } else if (that.questions[index].type == "3") {
            that.tebActive = "judge";
          }
          that.answerForm.answer_data[index] = obj;
          that.questionData = {
            data: that.questions[index],
            index: index,
            form: that.answerForm.answer_data[index],
            isAssess: '1',
          };
        }
      });
    },
    //跳转下一题
    next() {
      if (this.currentIndex < this.questions.length - 1) {
        // this.$refs.li[this.currentIndex + 1].click();
        this.eveyoneQuesFunc('next',this.currentIndex + 1)
      }
      if (this.currentIndex == this.questions.length - 1) {
        this.$refs.buNext.style.background = "#ECEAEA";
        this.$refs.buNext.style.color = "#999999";
        this.$refs.buNext.style.cursor = "not-allowed";
      } else {
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#999999";
      }
    },
    //跳转上一题
    previous() {
      if (this.currentIndex > 0) {
        //  this.$refs.li[this.currentIndex - 1].click();
        this.eveyoneQuesFunc('prev', this.currentIndex - 1)
      }
      if (this.currentIndex == 0) {
        this.$refs.buPrevious.style.cursor = "not-allowed";
        this.$refs.buPrevious.style.background = "#ECEAEA";
        this.$refs.buPrevious.style.color = "#999999";
      } else {
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#999999";
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
      }
    },
    //提交
    submit() {
      this.eveyoneQuesFunc('last', this.currentIndex)
    },
    // 点击上一题 下一题 题号 先提交当前题目
    async eveyoneQuesFunc(type, currentInx){
      // type prev上一题 next下一题 current点击题号 last点击提交
      let that = this;
      let params = {
        chapter_id: this.answerForm.chapter_id,
        exe_id: this.answerForm.exe_id,
        que_id: this.questionId,
        subtype: type == 'last' ? 2 : 1,
      }
      let isAnswer = false  // 当前题目是否答题了
      this.answerForm.answer_data.forEach(function (item) {
        if (item.que_id == that.questionId) {
          if (item.is_sign == "1" || item.answer || (item.attachment  && item.attachment.length > 0)) {
            let allfile = []
            if(item.attachment && item.attachment.length > 0){
              allfile = that.stringToAttachment(item.attachment)
            }
            params = Object.assign(params, {
              is_sign: item.is_sign,
              answer: item.answer,
              que_id: item.que_id,
            })
            if(allfile.length > 0 ){
              params.attachment = JSON.stringify(allfile)
            }
            isAnswer = true;
          }
        }
      });
      // 如果答题了 去提交单个题目
      if(type == "last" || isAnswer){
        if(that.isSubmitting == false){
          that.isSubmitting == true
          await this.exercisesQuesition(params).then(res => {
            that.isSubmitting == false
            if(res.code == '0000'){
              if(type == 'prev' || type == 'next'){
                this.toQuestion(this.questions[currentInx], currentInx, true)
              }
            }
          }).catch(err => {
            that.isSubmitting == false
          })
        }
      } else {
        if(type == 'prev' || type == 'next'){
          this.toQuestion(this.questions[currentInx], currentInx, true)
        }
      }
    },
    // 将学生答题的附件列表 格式化为提交参数
    stringToAttachment(list) {
      let newdata = [];
      if(list.length > 0) {
        list.forEach(element => {
          if(element.type == 'video'){
            newdata.push({
              file_name: element.filename,
              file_id: element.file_id, // 视频会上传腾讯云返回的file_id
              file_path: '',
              cover: '', // 视频视频封面
              file_url: element.file_url, // 视频的腾讯播放地址
            })
          } else {
            newdata.push({
              file_name: element.filename,
              file_path: element.url,
              file_id: '',
              cover: '',
              file_url: '',
            })
          }
        });
      } 
      return newdata
    },
    // 提交练习的单个答题/完整练习 的请求
    exercisesQuesition (params) {
      let that = this
      return services.postUserExercisesSubmit(params).then((res) => {
        if (res.code == "0000") {
          if(params.subtype == 2){  // 1单个题目提交2练习提交(
            that.$router.push({
              path: `/${this.userAllInfo.school_code}/user/myPractice/AgainPractice`,
              query: {
                chapter_id: this.$route.query.chapter_id,
                name: this.$route.query.name,
                exe_id: this.$route.query.exe_id,
              },
            });
          }
        } else {
          this.$message.warning(res.message ? res.message : "提交失败");
        }
        return res
      });
    },
  },
};
</script>

<style lang="less" scoped>
.c {
  padding-top: 10px;
}
.return {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2462f5;
  line-height: 32px;
  cursor: pointer;
  float: left;
  margin-top: 3px;
}
.main {
  background: #f6f6f6;
  padding-bottom: 10px;
}
.UserNav {
  box-shadow: 0px 0px 21px 0px rgba(25, 52, 116, 0.15);
}
.title {
  height: 40px;
  background: #fff;
  border-top: 3px solid #90b1ff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  text-align: center;
}
.title .chapterName {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 40px;
}
.paper {
  margin-top: 20px;
  position: relative;
  padding-bottom: 80px;
}
.paper-left {
  width: calc(100% - 330px);
  height: auto;
  min-height: 530px;
  background: #ffffff;
  margin-right: 20px;
  float: left;
}
.paper-right {
  width: 310px;
  /* max-height: 566px; */
  background: #ffffff;
  float: left;
  padding-bottom: 20px;
}
.paper-right-title {
  width: 56px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #14202c;
  line-height: 32px;
  margin-top: 10px;
  margin-left: 30px;
}
.paper:after {
  content: "";
  display: block;
  clear: both; /* height: 0;overflow: hidden; 为了解决 IE 浏览器的兼容问题 */
  height: 0;
  overflow: hidden; /* visibility:hidden;为了去隐藏content中的内容 */
  visibility: hidden;
}
.button-box {
  padding-top: 30px;
  box-sizing: border-box;
  margin-top: 10px;
  height: 80px;
  background: #fff;
  position: fixed;
  bottom: 0;
  width: 870px;
  z-index: 10;
}
.button-box div {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 22px;
  margin: 0 166px;
  display: inline-block;
  vertical-align: top;
}
.buPrevious {
  background: rgb(236, 234, 234);
  color: #999999;
  cursor: not-allowed;
}
.buPrevious:hover {
  background: #bbcdf3 !important;
  color: #ffffff !important;
}
.buNext {
  background: #2462f5;
  color: #fff;
  cursor: pointer;
}
.buNext:hover {
  background: #134bce !important;
  color: #ffffff !important;
}

.tip {
  height: 32px;
  display: flex;
  align-items: center;
  margin-left: 37px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.tip span {
  width: 29px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 32px;
  margin-right: 8px;
}
.answered {
  width: 16px;
  height: 16px;
  background: #dbe6fd;
  float: left;
  margin-right: 28px;
}
.noAnswer {
  width: 16px;
  height: 16px;
  background: #ffffff;
  border: 1px solid #e4e4e4;
  float: left;
}
.submit {
  color: #fff;
  width: 220px;
  height: 30px;
  background: #2462f5;
  border-radius: 22px;
  line-height: 30px;
  text-align: center;
  margin-left: 45px;
  cursor: pointer;
}
.submit:hover {
  background: #134bce !important;
  color: #ffffff !important;
}
.paper-right-selects {
  overflow-y: auto;
  ul {
    display: flex;
    flex-wrap: wrap;
    margin-left: 30px;
  }
  li {
    width: 32px;
    padding: 0 0;
    height: 32px;
    line-height: 32px;
    text-align: center;
    float: left;
    margin-right: 20px;
    margin-top: 15px;
    border: 1px solid #e4e4e4;
    cursor: pointer;
    font-size: 12px;
    position: relative;
  }
  li:hover {
    background: #dbe6fd;
    color: #999999;
  }
  li img {
    height: 14px;
    width: 14px;
    position: absolute;
    top: -7px;
    right: -7px;
  }
}
::-webkit-scrollbar-thumb {
  background-color: #dddddd;
  background-clip: padding-box;
  min-height: 28px;
}
</style>